module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "nighttime-lights--dataset-cover.1cd08e26.jpg";